<template>
  <div class="vue_watermark" ref="vue_watermark">
    <div
      v-for="(cell, index) in watermarkCells"
      :key="index"
      class="watermark-cell"
      :style="cell.style"
    >
      <div
        style="text-align: left;white-space:nowrap;"
        v-for="(text, index) in texts"
        :key="text + index"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Watermark",
  props: {
    texts: {
      type: Array,
      default: () => ["watermark"]
    },
    density: {
      type: Number,
      default:1
    },
    oddStyle: {
      type: Object,
      default: () => ({
        color: "#333",
            opacity: "0.3"
      })
    },
    evenStyle: {
      type: Object,
      default: () => ({
        color: "#ccc",
            opacity: "0.15"
      })
    },
    fontSize: {
      type: String,
      default: "25px"
    },
    col_space: {
      type: Number,
      default: 250
    },
    row_space: {
      type: Number,
      default: 180
    }
  },
  data() {
    return {
      watermarkCells: []
    };
  },
  mounted() {
    this.createWatermark();
    window.addEventListener("resize", this.resize_handler);
    this.observe()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize_handler);
  },
  methods: {
    observe(){
      // const observe = new MutationObserver(()=>{
      //   console.log(123)
      // })
      // observe.observe(document.body, {childList:true, attributes: true, subtree: true})
    },
    createWatermark() {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const cellWidth = this.col_space;
      const cellHeight = this.row_space;
      const rows = Math.ceil(height / (cellHeight * this.density)) + 1;
      const cols = Math.ceil(width / (cellWidth * this.density));
      const cells = new Array(rows * cols).fill({}).map((item, index) => {
        const row = Math.floor(index / cols);
        const col = index % cols;
        const style = {
          top: row * cellHeight * this.density + "px",
          left: col * cellWidth * this.density + "px",
          ...((row + col) % 2 === 0 ? this.evenStyle : this.oddStyle),
          transform: `rotate(-30deg)`,
          transformOrigin: "0 0",
          fontSize: this.fontSize,
          textAlign: "left",
          fontFamily: "OneNikeCurrency 微软雅黑",
          pointerEvents: "none",
          position: "fixed",
          zIndex: "9999"
        };
        return {
          style
        };
      });
      this.watermarkCells = cells;
      console.log(rows, cols, "asdadsadasdasdasd")
    },
    resize_handler() {
      this.$refs.vue_watermark.style.width = "100%";
      this.$refs.vue_watermark.style.height = "100%";
      this.watermarkCells = [];
      this.$nextTick(() => {
        this.createWatermark();
      });
    }
  }
};
</script>

<style>
.vue_watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 19999;
  pointer-events: none;
}

.watermark-cell {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/custom_watermark/customWatermark.vue